export default __webpack_public_path__ + "static/media/img-hero.2fdc7adb.jpg";